export const pictureFormat: string[] = [
  'image/apng',
  'image/avif',
  'image/bmp',
  'image/gif',
  'image/vnd.microsoft.icon',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'application/vnd.visio',
  'image/webp',
  'photo',
  'image',
];

export const videoFormat: string[] = [
  'video/x-msvideo',
  'video/mp4',
  'video/mpeg',
  'video/ogg',
  'video/mp2t',
  'video/webm',
  'video/3gpp',
  'video/3gpp2',
  'video',
  'movie',
  'video/quicktime',
];

export const audioFormat: string[] = [
  'audio/aac',
  'application/x-cdf',
  'audio/midi',
  'audio/x-midi',
  'audio/mpeg',
  'audio/ogg',
  'audio/wav',
  'audio/webm',
  'audio/3gpp',
  'audio/3gpp2',
  'application/x-7z-compressed',
  'audio',
];

export const archiveFormat: string[] = [
  'application/x-freearc',
  'application/x-bzip',
  'application/x-bzip2',
  'application/gzip',
  'application/x-gzip',
  'application/java-archive',
  'application/vnd.apple.installer+xml',
  'application/vnd.rar',
  'application/x-tar',
  'application/zip',
  'application/x-zip-compressed',
  'zip',
  'rar',
  'tar',
];

export const textFormat: string[] = [
  'application/x-abiword',
  'application/vnd.amazon.ebook',
  'application/octet-stream',
  'application/x-csh',
  'text/css',
  'text/csv',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/epub+zip',
  'application/vnd.ms-fontobject',
  'text/html',
  'text/calendar',
  'text/javascript',
  'application/json',
  'application/ld+json',
  'text/javascript',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'font/otf',
  'application/pdf',
  'application/x-httpd-php',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/rtf',
  'application/x-sh',
  'font/ttf',
  'text/plain',
  'font/woff',
  'font/woff2',
  'application/xhtml+xml',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/xml',
  'application/atom+xml',
  'application/vnd.mozilla.xul+xml',
  'pdf',
  'word',
  'text',
  'txt',
  'json',
  'pptx',
];
